import React from 'react';
import KeywordFormSection from './components/KeywordFormSection';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from 'components/core';
import { Inline, Stack } from 'components/layout';

type HighlightsModalProps = {
  isOpen: boolean;
  includedKeywords: string[];
  excludedKeywords: string[];
  handleClose: () => void;
};

const HighlightsModal = ({
  isOpen,
  handleClose,
  includedKeywords,
  excludedKeywords,
}: HighlightsModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="lg"
      aria-label="Manage Highlights"
    >
      <ModalHeader>Manage Highlights</ModalHeader>
      <ModalBody>
        <Stack spacing={5}>
          <Text variant="neutral">
            Highlights help to quickly spot words or phrases during screening by
            automatically highlighting inclusion words in green and exclusion
            words in red.
          </Text>

          <Inline component="form" alignY="top" shouldWrap spacing={5}>
            <KeywordFormSection
              title="Inclusion"
              titleColor="success"
              label="Add inclusion word"
              keywords={includedKeywords}
            />

            <KeywordFormSection
              title="Exclusion"
              titleColor="danger"
              label="Add exclusion word"
              keywords={excludedKeywords}
            />
          </Inline>
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Button type="brand" onClick={handleClose}>
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default HighlightsModal;
